<template>
  <div class="unmudl_widget explore_program progress">

    <div id="progressDetailPopover"></div>

    <b-popover container="progressDetailPopover" target="progressPopupTarget" triggers="click" :show.sync="$parent.showProgressPopover" :placement="'left'">
      <div class="row">
        <div class="col-12">

          <div class="close_btn_container">
            <button class="btn_close" aria-label="close" @click="closeProgressPopover">
              <span class="ic-close"></span>
            </button>
          </div>

          <div class="popup_hd">
            <span>{{courseTitle}}</span>
          </div>

          <div class="logo_sec">
            <span v-if="institution.logo">
              <img class="logo" :src="institution.logo">
            </span>
            <span v-else>{{institution.title}}</span>
          </div>


          <b-tabs v-model="tabIndex">
            <b-tab no-body title="" :title-link-class="linkClass(0)" title-item-class="w-50 text-center" :disabled="certificates.length === 0">

              <template v-if="certificates.length > 0">
                <div v-for="(program, index) in certificates">

                  <div class="row sec_hd" style="padding: 5px 15px; margin-top: 0px;">
                    <div class="col-8 hd_txt">
                      <span class="title">{{program.title}}</span>
                    </div>
                    <div class="col-4 hd_lnk1">
                      <b-link @click="goToCareerProspect(program)" class="sec_lnk">View Career Prospects</b-link>
                    </div>
                  </div>

                  <div class="row popup_content_container">
                    <div class="col-12 popup_content">

                      <b-collapse :id="'certificateProgram_' + index" visible class="col-12">

                      <div class="row">
                        <div class="col-12 mt-3 mb-1">
                          <strong>{{program.selectedCredit}}</strong> selected and
                          <span v-if="isGusetLogin">
                            <strong>?</strong>
                          </span>
                          <span v-else>
                            <strong>{{program.progress.completed}}</strong>
                          </span> completed
                          out of <strong>{{program.progress.total}}</strong> credits
                        </div>
                      </div>

                      <div class="row progress_bar_details">
                        <div class="col-10 progress_bar_container">
                          <b-progress :max="100" class="w-100" height="20px" style="background-color: #d1d1d1 !important;">
                            <b-progress-bar :value="((program.selectedCredit/program.progress.total)*100)" variant="selected"></b-progress-bar>
                            <b-progress-bar v-if="isGusetLogin" :value="5" class="w-5" variant="completed"></b-progress-bar>
                            <b-progress-bar v-else :value="((program.progress.completed/program.progress.total)*100)" variant="completed"></b-progress-bar>
                          </b-progress>
                        </div>
                        <div class="col-2 progress_value">
                          {{program.completion}}%
                        </div>
                      </div>

                    <template v-show="isCertificatePieChartGenerated">
                      <div class="row popup_grph">
                        <div class="col-12">

                          <div class="row sec_hd">
                            <div class="col-6 hd_txt">Credit Breakdown</div>
                            <div class="col-6 hd_info">Last Updated: {{lastUpdatedDateTime(program.progress)}}</div>
                          </div>

                          <div class="row">
                            <div class="col-4 donut_container">
                              <div class="program_credit" :id="'certificateProgressChart_' + index"></div>
                              <div class="progress_value">
                                {{program.completion}}%
                              </div>
                            </div>
                            <div class="col-4 legend_detail">
                              <!--
                              <div class="status_row"><span class="lg_blc transferred"></span>Transferred</div>
                              <div class="status_row"><span class="lg_blc in_progress"></span>In Progress</div>
                              <div class="status_row"><span class="lg_blc in_the_plan"></span>In the Plan</div>
                              -->
                              <div class="status_row"><span class="lg_blc credits_selected"></span>Selected</div>
                              <div class="status_row"><span class="lg_blc credits_needed"></span>Missing</div>
                              <div class="status_row" style="margin-bottom: 0px;"><span class="lg_blc completed"></span>Completed</div>
                              <div class="status_row" style="margin: 0px;">
                                <template class="row m-2" v-if="program.selectedCourses && program.selectedCourses.length > 0">
                                  <b-link @click="openAddCoursePopup(program)" class="sec_lnk" style="padding-left: 0px;">Add Completed Courses</b-link>
                                </template>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                      <template class="row m-2" v-if="program.selectedCourses && program.selectedCourses.length > 0">

                        <!--
                        <div class="row">
                          <div class="col-12">

                          </div>
                          <div class="col-12">No, Thanks. I don't have anything to add now.</div>
                        </div>
                        -->

                        <div class="row widget_course_list">
                          <div class="col-12">

                            <div class="row title_row">
                              <span class="col-7 title_txt">Awarded Credits for Selected Course</span>
                              <span class="col-5 credit_details">{{program.selectedCourses.length}} Courses / {{program.selectedCredit}} Credits</span>
                            </div>

                            <div class="row">
                              <div class="col-12">
                                <div class="row tbl_hd">
                                  <div class="col-9 course_name">Course Code and Course Name</div>
                                  <div class="col-3 credits">Credits</div>
                                </div>
                                <div class="row tbl_content">
                                  <div class="col-12">
                                    <div class="row tbl_row" v-for="course in program.selectedCourses">
                                      <div class="col-11 course_name">{{course.title}}</div>
                                      <div class="col-1 credits">
                                        <span class="credits_txt">{{course.credit}}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>

                      </template>
                    </template>

                    </b-collapse>

                    </div>
                  </div>

                </div>
              </template>

          </b-tab>

          <b-tab no-body title="" :title-link-class="linkClass(1)" title-item-class="w-50 text-center" :disabled="degrees.length === 0">

            <template v-if="degrees.length > 0">
              <div v-for="(program, index) in degrees">

                <div class="row sec_hd" style="padding: 5px 15px; margin-top: 0px;">
                  <div class="col-8 hd_txt">
                    <span class="title">{{program.title}}</span>
                  </div>
                  <div class="col-4 hd_lnk1">
                    <b-link @click="goToCareerProspect(program)">View Career Prospects</b-link>
                  </div>
                </div>

                <div class="row popup_content_container">
                  <div class="col-12 popup_content">

                    <b-collapse :id="'degreeProgram_' + index" visible class="col-12">

                    <template v-show="isDegreePieChartGenerated">

                      <div class="row">
                        <div class="col-12 mt-3 mb-1">
                          <strong>{{program.selectedCredit}}</strong> selected and
                          <span v-if="isGusetLogin">
                            <strong>?</strong>
                          </span>
                          <span v-else>
                            <strong>{{program.progress.completed}}</strong>
                          </span> completed
                          out of <strong>{{program.progress.total}}</strong> credits
                        </div>
                      </div>

                      <div class="row progress_bar_details">
                        <div class="col-10 progress_bar_container">
                          <b-progress :max="100" class="w-100" height="20px" style="background-color: #d1d1d1 !important;">
                            <b-progress-bar :value="((program.selectedCredit/program.progress.total)*100)" variant="selected"></b-progress-bar>
                            <b-progress-bar v-if="isGusetLogin" :value="5" class="w-5" variant="completed"></b-progress-bar>
                            <b-progress-bar v-else :value="((program.progress.completed/program.progress.total)*100)" variant="completed"></b-progress-bar>
                          </b-progress>
                        </div>
                        <div class="col-2 progress_value">
                          {{program.completion}}%
                        </div>
                      </div>

                      <div class="row popup_grph">
                        <div class="col-12">

                          <div class="row sec_hd">
                            <div class="col-6 hd_txt">Credit Breakdown</div>
                            <div class="col-6 hd_info">Last Updated: {{lastUpdatedDateTime(program.progress)}}</div>
                          </div>


                          <div class="row">
                            <div class="col-4 donut_container">
                              <div class="program_credit" :id="'degreeProgressChart_' + index"></div>
                              <div class="progress_value">
                                {{program.completion}}%
                              </div>
                            </div>
                            <div class="col-4 legend_detail">
                              <!--
                              <div class="status_row"><span class="lg_blc transferred"></span>Transferred</div>
                              <div class="status_row"><span class="lg_blc in_progress"></span>In Progress</div>
                              <div class="status_row"><span class="lg_blc in_the_plan"></span>In the Plan</div>
                              -->
                              <div class="status_row"><span class="lg_blc credits_selected"></span>Selected</div>
                              <div class="status_row"><span class="lg_blc credits_needed"></span>Missing</div>
                              <div class="status_row" style="margin-bottom: 0px;"><span class="lg_blc completed"></span>Completed</div>
                              <div class="status_row" style="margin: 0px; height: 25px;">
                                <b-link @click="openAddCoursePopup(program)" class="sec_lnk" style="padding-left: 0px;">Add Completed Courses</b-link>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                      <template v-if="program.selectedCourses && program.selectedCourses.length > 0">

                        <div class="row widget_course_list">
                          <div class="col-12">

                            <div class="row title_row">
                              <span class="col-7 title_txt">Awarded Credits for Selected Course</span>
                              <span class="col-5 credit_details">{{program.selectedCourses.length}} Courses / {{program.selectedCredit}} Credits</span>
                            </div>

                            <div class="row">
                              <div class="col-12">
                                <div class="row tbl_hd">
                                  <div class="col-9 course_name">Course Code and Course Name</div>
                                  <div class="col-3 credits">Credits</div>
                                </div>
                                <div class="row tbl_content">
                                  <div class="col-12">
                                    <div class="row tbl_row" v-for="course in program.selectedCourses">
                                      <div class="col-11 course_name">{{course.title}}</div>
                                      <div class="col-1 credits">
                                        <span class="credits_txt">{{course.credit}}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>

                      </template>
                    </template>

                  </b-collapse>

                  </div>
                </div>

              </div>
            </template>

          </b-tab>
        </b-tabs>

        </div>
      </div>
    </b-popover>

    <template v-if="showAddCoursePopover && programId && programCode">
      <unmudl-explore-add-completed-course
        :program-id="programId"
        :program-code="programCode"
        :selected-courses="selectedCourses">
      </unmudl-explore-add-completed-course>
    </template>

  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { DateTime } from 'luxon'
  import { PACKAGE } from '../../../package_constants'
  import * as d3 from 'd3'
  import UnmudlExploreAddCompletedCourse from './UnmudlExploreAddCompletedCourse'
  import '../../../assets/module/css/webWidget/webWidget_Unmudl.min.css'
  import { StorageFactory } from '../../../storageFactory'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'unmudl-explore-program-progress',
    props: ['institutionId', 'courseTitle', 'program'],
    components: {
      UnmudlExploreAddCompletedCourse
    },
    data: () => {
      return {
        tabIndex: 0,
        certificates: [],
        degrees: [],
        isCertificatePieChartGenerated: false,
        isDegreePieChartGenerated: false,
        showAddCoursePopover: false,
        programId: undefined,
        programCode: undefined,
        selectedCourses: []
      }
    },
    updated () {
      this.$nextTick(() => {
        this.populateProgressAndGeneratePieChart()
      })
    },
    async mounted () {
      this.tabIndex = this.$parent.tabIndex
      this.populateData()
      await this.loadInstitutionDetail(this.institutionId)
      await this.loadInstitutionPackage({uuid: this.institutionId, isAggregated: false})
    },
    methods: {
      ...mapActions([
        'loadInstitutionDetail',
        'loadInstitutionPackage',
        'loadNavigateToCareerProspect'
      ]),
      populateData () {
        if (this.program.type === 'CERT') {
          this.certificates.push(this.program)
        } else {
          this.degrees.push(this.program)
        }
      },
      linkClass (idx) {
        if (this.tabIndex === idx) {
          return ['active']
        } else {
          return ['tab-bg-primary']
        }
      },
      openLoginPopup () {
        this.$parent.tabIndex = this.tabIndex
        window.parent.postMessage({name: 'WidgetLogin'}, '*')
        this.$parent.showProgressPopover = false
      },
      goToCareerProspect (program) {
        if (this.isGusetLogin) {
          localStore.setItem('isViewCareerProspectClicked', 'yes')
          this.openLoginPopup()
        } else {
          localStore.removeItem('isViewCareerProspectClicked')
          this.closeProgressPopover()
          let token = localStore.getItem('token')
          let cipCode = program.cipCode
          let code = program.code
          let type = program.type
          let selected = program.selectedCredit
          this.loadNavigateToCareerProspect(token).then(href => {
            href += '&cipCode=' + cipCode + '&code=' + code + '&type=' + type + '&selected=' + selected
            window.open(href, '_blank')
          })
        }
      },
      openAddCoursePopup (program) {
        if (this.isGusetLogin) {
          localStore.setItem('isAddCompletedCourseClicked', 'yes')
          this.openLoginPopup()
        } else {
          localStore.removeItem('isAddCompletedCourseClicked')
          this.programCode = program.code
          this.programId = program.progress.programId
          this.selectedCourses = program.selectedCourses
          this.showAddCoursePopover = true
        }
      },
      closeProgressPopover () {
        this.programId = undefined
        this.programCode = undefined
        this.$parent.tabIndex = this.tabIndex
        this.showAddCoursePopover = false
        this.$parent.showProgressPopover = false
        window.parent.postMessage({name: 'HideDetail'}, '*')
        $('.program_popup_layer').display = 'none'
      },
      populateProgressAndGeneratePieChart () {
        $('.program_popup_layer').display = 'block'
        if (this.tabIndex === 0) {
          this.certificates.forEach((program, i) => {
            let progress = program.progress
            if (progress) {
              let elementId = 'certificateProgressChart_' + i
              if (this.isShowCourseProgressEnabled) {
                let colorScale = {
                  'transferred courses': '#56b5e8',
                  'completed courses': '#1890ff',
                  'in progress courses': '#aac76b',
                  'scheduled courses': '#f5b318',
                  'courses needed': '#d2d2d2',
                  'courses selected': '#532a6e'
                }
                this.generatePieChart(progress.courseValues, colorScale, elementId)
                this.isCertificatePieChartGenerated = true
              } else {
                let colorScale = {
                  'transferred': '#56b5e8',
                  'completed': '#1890ff',
                  'in progress': '#aac76b',
                  'scheduled': '#f5b318',
                  'credits needed': '#d2d2d2',
                  'credits selected': '#532a6e'
                }
                this.generatePieChart(progress.values, colorScale, elementId)
                this.isCertificatePieChartGenerated = true
              }
            }
          })
        } else {
          this.degrees.forEach((program, i) => {
            let progress = program.progress
            if (progress) {
              let elementId = 'degreeProgressChart_' + i
              if (this.isShowCourseProgressEnabled) {
                let colorScale = {
                  'transferred courses': '#56b5e8',
                  'completed courses': '#1890ff',
                  'in progress courses': '#aac76b',
                  'scheduled courses': '#f5b318',
                  'courses needed': '#d2d2d2',
                  'courses selected': '#532a6e'
                }
                this.generatePieChart(progress.courseValues, colorScale, elementId)
                this.isDegreePieChartGenerated = true
              } else {
                let colorScale = {
                  'transferred': '#56b5e8',
                  'completed': '#1890ff',
                  'in progress': '#aac76b',
                  'scheduled': '#f5b318',
                  'credits needed': '#d2d2d2',
                  'credits selected': '#532a6e'
                }
                this.generatePieChart(progress.values, colorScale, elementId)
                this.isDegreePieChartGenerated = true
              }
            }
          })
        }
      },
      generatePieChart (data, colorScale, elementId) {
        $('#' + elementId).empty()
        var pieChartContainerHeight = 180
        var pieChartInnerRadius = 60
        var width = pieChartContainerHeight
        var height = pieChartContainerHeight
        var radius = pieChartContainerHeight / 2

        if (typeof data[0].value !== 'undefined' && data[0].label === 'credits needed') {
          var missingValue = data[0].value
        }
        if (typeof data[1].value !== 'undefined') {
          var selectedValue = data[1].value
        }
        if (this.isGusetLogin) {
          data = [{label: 'credits selected', value: selectedValue}, {label: 'completed', value: '6'}, {label: 'credits needed', value: (missingValue - 6)}]
        }

        var canvas = d3.select('#' + elementId).append('svg')
                     .data([data]).attr('width', width).attr('height', height).append('g')
                     .attr('transform', 'translate(' + radius + ',' + radius + ')')

        var arc = d3.arc()
                  .outerRadius(radius)
                  .innerRadius(pieChartInnerRadius)

        var pie = d3.pie()
                  .value(function (d) { return d.value }).sort(null)

        var arcs = canvas.selectAll('.arc')
                   .data(pie(data))
                   .enter().append('g')
                   .attr('class', 'arc')

        arcs.append('path')
            .attr('d', arc)
            .style('fill', function (d, i) { return colorScale[d.data.label] })

        arcs.append('text')
            .attr('transform', function (d) { return 'translate(' + arc.centroid(d) + ')' })
            .style('font', 'bold 12px Arial')
            .style('fill', '#fff')
            .style('cursor', 'default')
            .attr('text-anchor', 'middle')
            .text((d) => { return (this.isGusetLogin && ((d.data.label.indexOf('completed') !== -1) || (d.data.label.indexOf('needed') !== -1))) ? '?' : ((d.data.value > 0) ? d.data.value : '') })
      },
      changeMillisToDate (millis, format) {
        return DateTime.fromMillis(millis, {zone: 'utc'}).toFormat(format)
      },
      lastUpdatedDateTime (progress) {
        return (progress) ? this.changeMillisToDate(progress.lastUpdatedTime, 'MMM dd, yyyy') : ''
      }
    },
    computed: {
      ...mapState({
        'institution': state => state.institution.institution,
        'enabledFeatures': state => state.institution.enabledFeatures
      }),
      isGusetLogin () {
        return (localStore.getItem('userrole') === 'Guest')
      },
      isShowCourseProgressEnabled () {
        let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
        if (progressViewFeature && progressViewFeature.enabled) {
          let flags = progressViewFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showCourseProgressOnOverall') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      isShowCreditProgressEnabled () {
        let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
        if (progressViewFeature && progressViewFeature.enabled) {
          let flags = progressViewFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showCreditProgress') {
              return flags[i].enabled
            }
          }
        }
        return false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/widget/components/UnmudlExploreProgramProgress.vue